<div class="file-input-history-wrapper">
  <app-form-section-header [title]="titleKey | translate"></app-form-section-header>

  @if (uploadError) {
    <div class="alert alert-danger">
      {{ uploadError }}
    </div>
  }

  @if (removeError) {
    <div class="alert alert-danger">
      {{ removeError }}
    </div>
  }

  <div class="files-container" [class.has-overlay]="isUploading || hasRemovingItems()">
    @if (isUploading || hasRemovingItems()) {
      <div class="loading-overlay">
        <app-circular-progress
          [value]="currentUploadProgress"
          [total]="100"
          [showPercentage]="true"
          [size]="80"
          [thickness]="12"
        ></app-circular-progress>
        @if (isUploading) {
          <p class="mt-2 mb-0 overlay-text">
            {{ uploadStatus || ('FILE_INPUT_HISTORY.UPLOADING' | translate) }}
          </p>
        }
        @if (!isUploading && hasRemovingItems()) {
          <p class="mt-2 mb-0 overlay-text">
            {{ 'FILE_INPUT_HISTORY.DELETING' | translate }}
          </p>
        }
      </div>
    }

    @for (attachment of filteredAttachments; track attachment) {
      <div class="file-item">
        <div class="file-info">
          <span class="file-label">{{ 'FILE_INPUT_HISTORY.FILE_NAME' | translate }}</span>
          <span class="file-name">{{ attachment.fileName || ('FILE_INPUT_HISTORY.NO_NAME' | translate) }}</span>
        </div>
        <div class="file-actions">
          @if (getAttachmentId(attachment)) {
            <button
              type="button"
              class="btn-action btn-download"
              [disabled]="isCurrentlyDownloading(getAttachmentId(attachment)!)"
              (click)="downloadDocument(getAttachmentId(attachment)!, attachment.fileName)"
              >
              @if (!isCurrentlyDownloading(getAttachmentId(attachment)!)) {
                <span>
                  {{ 'FILE_INPUT_HISTORY.DOWNLOAD' | translate }}
                </span>
              }
              @if (isCurrentlyDownloading(getAttachmentId(attachment)!)) {
                <span>
                  {{ 'FILE_INPUT_HISTORY.DOWNLOADING' | translate }}
                </span>
              }
            </button>
          }
          @if (getAttachmentId(attachment) && !disabled) {
            <button
              type="button"
              class="btn-action btn-delete"
              [disabled]="isCurrentlyRemoving(getAttachmentId(attachment)!)"
              (click)="deleteDocument(getAttachmentId(attachment)!)"
              >
              {{ 'FILE_INPUT_HISTORY.DELETE' | translate }}
            </button>
          }
        </div>
      </div>
    }

    @if (!filteredAttachments || filteredAttachments.length === 0) {
      <div class="no-files-message">
        <i class="bi bi-inbox text-muted mb-2" style="font-size: 2rem"></i>
        <p class="mb-0">{{ noFilesKey | translate }}</p>
      </div>
    }
  </div>

  <div class="upload-section">
    <app-file-input
      [accept]="accept"
      [multiple]="false"
      [labelKey]="uploadLabelKey"
      [showTitle]="false"
      [hideLabel]="hideUploadLabel"
      [infoPopover]="infoPopover"
      (fileSelected)="onFileSelected($event)"
      />
  </div>
</div>
